import { render, staticRenderFns } from "./StepContainer.vue?vue&type=template&id=56deebae&lang=pug&"
import script from "./StepContainer.vue?vue&type=script&lang=js&"
export * from "./StepContainer.vue?vue&type=script&lang=js&"
import style0 from "./StepContainer.vue?vue&type=style&index=0&id=56deebae&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports